<div class="search-for">
  <mat-icon>search</mat-icon>
  <mat-form-field cclass="search-text">
    <input matInput type="text" autocomplete="off" placeholder="{{placeholder}}"
           [formControl]="formControls.search"
           (input)="onSearch()">
  </mat-form-field>
</div>
